import { useEffect } from 'react';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

export function useScrollbarTheme() {
  const { theme } = useStyles();

  useEffect(() => {
    if (Platform.OS !== 'web') {
      return;
    }

    document.documentElement.style.setProperty(
      '--scrollbar-thumb',
      theme.colors.text.secondary50
    );

    document.documentElement.style.setProperty(
      '--scrollbar-track',
      theme.colors.card.default.borderColor
    );
  }, [theme]);
}
